import React from 'react';
import PropTypes from 'prop-types';

import {I18n} from '@aws-amplify/core';

import {Box, SimpleGrid, Title} from '@mantine/core';

const HeadingRow = ({ title, subtitle, text }) => {
    return (
        <SimpleGrid>
            <Title order={4}>{I18n.get(title)}</Title>
            <Box>{I18n.get(subtitle)}</Box>
            <Box>{I18n.get(text)}</Box>
        </SimpleGrid>
    );
};

HeadingRow.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
};

HeadingRow.defaultProps = {
    title: 'Sign In',
    subtitle: 'to continue to NEXT Cloud',
    text: '',
};

export default HeadingRow;
